/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Enumera los campos que pueden editarse de un programacion de actividad.
 */
export type ProgramacionActividadPatchFieldsEnum = 'activo' | 'incCupos' | 'comentarios' | 'valor' | 'timeZone' | 'horaInicio' | 'horaFin';

export const ProgramacionActividadPatchFieldsEnum = {
    Activo: 'activo' as ProgramacionActividadPatchFieldsEnum,
    IncCupos: 'incCupos' as ProgramacionActividadPatchFieldsEnum,
    Comentarios: 'comentarios' as ProgramacionActividadPatchFieldsEnum,
    Valor: 'valor' as ProgramacionActividadPatchFieldsEnum,
    TimeZone: 'timeZone' as ProgramacionActividadPatchFieldsEnum,
    HoraInicio: 'horaInicio' as ProgramacionActividadPatchFieldsEnum,
    HoraFin: 'horaFin' as ProgramacionActividadPatchFieldsEnum
};

